var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BgImageLayout',{attrs:{"title":"Imported subscriptions"}},[_c('AgGridWrapper',{attrs:{"options":_vm.gridOptions,"include-search-box":true,"title":"Previous imports"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }